var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewgenOneMarvin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 18,
    viewBox: "0 0 146 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.1308 5.31091C99.0507 5.55222 99.1133 5.81807 99.2927 5.99826L100.171 6.75454L100.151 6.73946L103.489 9.76577C103.645 9.90649 103.847 9.98444 104.056 9.98444C104.263 9.98444 104.463 9.90823 104.618 9.77034L106.056 8.48774L105.048 7.52156L104.083 8.46593L100.482 4.93516C100.286 4.74346 100.007 4.66372 99.74 4.72327L99.7272 4.7261C99.4577 4.78616 99.2395 4.98333 99.1525 5.24542L99.1308 5.31091ZM105.637 6.94436L106.674 7.93707L107.938 6.80954L107.951 13.849C107.951 14.218 108.251 14.5167 108.62 14.5167C108.989 14.5167 109.289 14.2172 109.289 13.8478V5.31991C109.289 4.8673 108.922 4.50039 108.469 4.50039C108.255 4.50039 108.049 4.58432 107.896 4.7342L105.637 6.94436Z",
    fill: "url(#paint0_linear_2215_20176)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.974 10.9958L100.341 9.36273L100.96 8.74352L102.594 10.3766L101.974 10.9958Z",
    fill: "url(#paint1_linear_2215_20176)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.3841 12.6957L99.3842 9.50866L100.258 9.50775L100.258 12.6948L99.3841 12.6957Z",
    fill: "url(#paint2_linear_2215_20176)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.332 12.8398L101.976 11.1956L102.592 11.8169L100.948 13.4611L100.332 12.8398Z",
    fill: "url(#paint3_linear_2215_20176)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.056 9.13901C100.281 9.13901 100.463 8.95706 100.463 8.73261C100.463 8.50817 100.281 8.32622 100.056 8.32622C99.832 8.32622 99.6501 8.50817 99.6501 8.73261C99.6501 8.95706 99.832 9.13901 100.056 9.13901ZM100.056 9.78906C100.64 9.78906 101.113 9.31607 101.113 8.73261C101.113 8.14916 100.64 7.67617 100.056 7.67617C99.473 7.67617 99.0001 8.14916 99.0001 8.73261C99.0001 9.31607 99.473 9.78906 100.056 9.78906Z",
    fill: "url(#paint4_linear_2215_20176)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.056 13.846C100.281 13.846 100.463 13.6641 100.463 13.4396C100.463 13.2152 100.281 13.0332 100.056 13.0332C99.832 13.0332 99.65 13.2152 99.65 13.4396C99.65 13.6641 99.832 13.846 100.056 13.846ZM100.056 14.4961C100.64 14.4961 101.113 14.0231 101.113 13.4396C101.113 12.8562 100.64 12.3832 100.056 12.3832C99.473 12.3832 99 12.8562 99 13.4396C99 14.0231 99.473 14.4961 100.056 14.4961Z",
    fill: "url(#paint5_linear_2215_20176)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.793 11.6019C103.018 11.6019 103.2 11.42 103.2 11.1955C103.2 10.9711 103.018 10.7891 102.793 10.7891C102.569 10.7891 102.387 10.9711 102.387 11.1955C102.387 11.42 102.569 11.6019 102.793 11.6019ZM102.793 12.2519C103.377 12.2519 103.85 11.779 103.85 11.1955C103.85 10.612 103.377 10.1391 102.793 10.1391C102.21 10.1391 101.737 10.612 101.737 11.1955C101.737 11.779 102.21 12.2519 102.793 12.2519Z",
    fill: "url(#paint6_linear_2215_20176)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M116.18 14.4984V12.9304L116.11 12.6364V9.96239C116.11 9.39306 115.942 8.95439 115.606 8.64639C115.279 8.32906 114.785 8.17039 114.122 8.17039C113.683 8.17039 113.254 8.24506 112.834 8.39439C112.414 8.53439 112.059 8.72572 111.77 8.96839L111.21 7.96039C111.593 7.65239 112.05 7.41906 112.582 7.26039C113.123 7.09239 113.688 7.00839 114.276 7.00839C115.293 7.00839 116.077 7.25572 116.628 7.75039C117.179 8.24506 117.454 9.00106 117.454 10.0184V14.4984H116.18ZM113.744 14.5824C113.193 14.5824 112.708 14.4891 112.288 14.3024C111.877 14.1157 111.56 13.8591 111.336 13.5324C111.112 13.1964 111 12.8184 111 12.3984C111 11.9971 111.093 11.6331 111.28 11.3064C111.476 10.9797 111.789 10.7184 112.218 10.5224C112.657 10.3264 113.245 10.2284 113.982 10.2284H116.334V11.1944H114.038C113.366 11.1944 112.913 11.3064 112.68 11.5304C112.447 11.7544 112.33 12.0251 112.33 12.3424C112.33 12.7064 112.475 13.0004 112.764 13.2244C113.053 13.4391 113.455 13.5464 113.968 13.5464C114.472 13.5464 114.911 13.4344 115.284 13.2104C115.667 12.9864 115.942 12.6597 116.11 12.2304L116.376 13.1544C116.199 13.5931 115.886 13.9431 115.438 14.2044C114.99 14.4564 114.425 14.5824 113.744 14.5824Z",
    fill: "url(#paint7_linear_2215_20176)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M120.324 14.4984V7.07839H121.612V9.09439L121.486 8.59039C121.691 8.07706 122.037 7.68506 122.522 7.41439C123.007 7.14372 123.605 7.00839 124.314 7.00839V8.31039C124.258 8.30106 124.202 8.29639 124.146 8.29639C124.099 8.29639 124.053 8.29639 124.006 8.29639C123.287 8.29639 122.718 8.51106 122.298 8.94039C121.878 9.36972 121.668 9.99039 121.668 10.8024V14.4984H120.324Z",
    fill: "url(#paint8_linear_2215_20176)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M128.686 14.4984L125.438 7.07839H126.838L129.722 13.7984H129.05L131.99 7.07839H133.306L130.058 14.4984H128.686Z",
    fill: "url(#paint9_linear_2215_20176)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M134.324 14.4984V7.07839H135.668V14.4984H134.324ZM134.996 5.65039C134.735 5.65039 134.515 5.56639 134.338 5.39839C134.17 5.23039 134.086 5.02506 134.086 4.78239C134.086 4.53039 134.17 4.32039 134.338 4.15239C134.515 3.98439 134.735 3.90039 134.996 3.90039C135.257 3.90039 135.472 3.98439 135.64 4.15239C135.817 4.31106 135.906 4.51172 135.906 4.75439C135.906 5.00639 135.822 5.22106 135.654 5.39839C135.486 5.56639 135.267 5.65039 134.996 5.65039Z",
    fill: "url(#paint10_linear_2215_20176)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M142.369 7.00839C142.976 7.00839 143.508 7.12506 143.965 7.35839C144.432 7.59172 144.796 7.94639 145.057 8.42239C145.318 8.89839 145.449 9.50039 145.449 10.2284V14.4984H144.105V10.3824C144.105 9.66372 143.928 9.12239 143.573 8.75839C143.228 8.39439 142.738 8.21239 142.103 8.21239C141.627 8.21239 141.212 8.30572 140.857 8.49239C140.502 8.67906 140.227 8.95439 140.031 9.31839C139.844 9.68239 139.751 10.1351 139.751 10.6764V14.4984H138.407V7.07839H139.695V9.08039L139.485 8.54839C139.728 8.06306 140.101 7.68506 140.605 7.41439C141.109 7.14372 141.697 7.00839 142.369 7.00839Z",
    fill: "url(#paint11_linear_2215_20176)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.47 14.5V4.7H2.618L9.1 12.75H8.498V4.7H9.898V14.5H8.75L2.268 6.45H2.87V14.5H1.47ZM15.9393 14.584C15.146 14.584 14.446 14.4207 13.8393 14.094C13.242 13.7673 12.7753 13.3193 12.4393 12.75C12.1127 12.1807 11.9493 11.5273 11.9493 10.79C11.9493 10.0527 12.108 9.39933 12.4253 8.83C12.752 8.26067 13.1953 7.81733 13.7553 7.5C14.3247 7.17333 14.964 7.01 15.6733 7.01C16.392 7.01 17.0267 7.16867 17.5773 7.486C18.128 7.80333 18.5573 8.25133 18.8653 8.83C19.1827 9.39933 19.3413 10.0667 19.3413 10.832C19.3413 10.888 19.3367 10.9533 19.3273 11.028C19.3273 11.1027 19.3227 11.1727 19.3133 11.238H12.9993V10.272H18.6133L18.0673 10.608C18.0767 10.132 17.9787 9.70733 17.7733 9.334C17.568 8.96067 17.2833 8.67133 16.9193 8.466C16.5647 8.25133 16.1493 8.144 15.6733 8.144C15.2067 8.144 14.7913 8.25133 14.4273 8.466C14.0633 8.67133 13.7787 8.96533 13.5733 9.348C13.368 9.72133 13.2653 10.1507 13.2653 10.636V10.86C13.2653 11.3547 13.3773 11.798 13.6013 12.19C13.8347 12.5727 14.1567 12.8713 14.5673 13.086C14.978 13.3007 15.4493 13.408 15.9813 13.408C16.42 13.408 16.8167 13.3333 17.1713 13.184C17.5353 13.0347 17.8527 12.8107 18.1233 12.512L18.8653 13.38C18.5293 13.772 18.1093 14.0707 17.6053 14.276C17.1107 14.4813 16.5553 14.584 15.9393 14.584ZM22.6389 14.5L19.8809 7.08H21.1549L23.6049 13.8H23.0029L25.5509 7.08H26.6849L29.1769 13.8H28.5889L31.0949 7.08H32.2989L29.5269 14.5H28.2389L25.9009 8.368H26.2929L23.9269 14.5H22.6389ZM36.7056 17.3C36.0243 17.3 35.3616 17.202 34.7176 17.006C34.0829 16.8193 33.5649 16.5487 33.1636 16.194L33.8076 15.158C34.1529 15.4567 34.5776 15.69 35.0816 15.858C35.5856 16.0353 36.1129 16.124 36.6636 16.124C37.5409 16.124 38.1849 15.9187 38.5956 15.508C39.0063 15.0973 39.2116 14.472 39.2116 13.632V12.064L39.3516 10.594L39.2816 9.11V7.08H40.5556V13.492C40.5556 14.7987 40.2289 15.76 39.5756 16.376C38.9223 16.992 37.9656 17.3 36.7056 17.3ZM36.5376 14.192C35.8189 14.192 35.1749 14.0427 34.6056 13.744C34.0456 13.436 33.5976 13.0113 33.2616 12.47C32.9349 11.9287 32.7716 11.3033 32.7716 10.594C32.7716 9.87533 32.9349 9.25 33.2616 8.718C33.5976 8.17667 34.0456 7.75667 34.6056 7.458C35.1749 7.15933 35.8189 7.01 36.5376 7.01C37.1723 7.01 37.7509 7.14067 38.2736 7.402C38.7963 7.654 39.2116 8.046 39.5196 8.578C39.8369 9.11 39.9956 9.782 39.9956 10.594C39.9956 11.3967 39.8369 12.064 39.5196 12.596C39.2116 13.128 38.7963 13.5293 38.2736 13.8C37.7509 14.0613 37.1723 14.192 36.5376 14.192ZM36.6916 13.016C37.1863 13.016 37.6249 12.9133 38.0076 12.708C38.3903 12.5027 38.6889 12.218 38.9036 11.854C39.1276 11.49 39.2396 11.07 39.2396 10.594C39.2396 10.118 39.1276 9.698 38.9036 9.334C38.6889 8.97 38.3903 8.69 38.0076 8.494C37.6249 8.28867 37.1863 8.186 36.6916 8.186C36.1969 8.186 35.7536 8.28867 35.3616 8.494C34.9789 8.69 34.6756 8.97 34.4516 9.334C34.2369 9.698 34.1296 10.118 34.1296 10.594C34.1296 11.07 34.2369 11.49 34.4516 11.854C34.6756 12.218 34.9789 12.5027 35.3616 12.708C35.7536 12.9133 36.1969 13.016 36.6916 13.016ZM46.4276 14.584C45.6343 14.584 44.9343 14.4207 44.3276 14.094C43.7303 13.7673 43.2636 13.3193 42.9276 12.75C42.6009 12.1807 42.4376 11.5273 42.4376 10.79C42.4376 10.0527 42.5963 9.39933 42.9136 8.83C43.2403 8.26067 43.6836 7.81733 44.2436 7.5C44.8129 7.17333 45.4523 7.01 46.1616 7.01C46.8803 7.01 47.5149 7.16867 48.0656 7.486C48.6163 7.80333 49.0456 8.25133 49.3536 8.83C49.6709 9.39933 49.8296 10.0667 49.8296 10.832C49.8296 10.888 49.8249 10.9533 49.8156 11.028C49.8156 11.1027 49.8109 11.1727 49.8016 11.238H43.4876V10.272H49.1016L48.5556 10.608C48.5649 10.132 48.4669 9.70733 48.2616 9.334C48.0563 8.96067 47.7716 8.67133 47.4076 8.466C47.0529 8.25133 46.6376 8.144 46.1616 8.144C45.6949 8.144 45.2796 8.25133 44.9156 8.466C44.5516 8.67133 44.2669 8.96533 44.0616 9.348C43.8563 9.72133 43.7536 10.1507 43.7536 10.636V10.86C43.7536 11.3547 43.8656 11.798 44.0896 12.19C44.3229 12.5727 44.6449 12.8713 45.0556 13.086C45.4663 13.3007 45.9376 13.408 46.4696 13.408C46.9083 13.408 47.3049 13.3333 47.6596 13.184C48.0236 13.0347 48.3409 12.8107 48.6116 12.512L49.3536 13.38C49.0176 13.772 48.5976 14.0707 48.0936 14.276C47.5989 14.4813 47.0436 14.584 46.4276 14.584ZM55.6579 7.01C56.2645 7.01 56.7965 7.12667 57.2539 7.36C57.7205 7.59333 58.0845 7.948 58.3459 8.424C58.6072 8.9 58.7379 9.502 58.7379 10.23V14.5H57.3939V10.384C57.3939 9.66533 57.2165 9.124 56.8619 8.76C56.5165 8.396 56.0265 8.214 55.3919 8.214C54.9159 8.214 54.5005 8.30733 54.1459 8.494C53.7912 8.68067 53.5159 8.956 53.3199 9.32C53.1332 9.684 53.0399 10.1367 53.0399 10.678V14.5H51.6959V7.08H52.9839V9.082L52.7739 8.55C53.0165 8.06467 53.3899 7.68667 53.8939 7.416C54.3979 7.14533 54.9859 7.01 55.6579 7.01ZM65.8452 14.612C65.0985 14.612 64.4032 14.486 63.7592 14.234C63.1245 13.982 62.5738 13.632 62.1072 13.184C61.6405 12.7267 61.2765 12.1947 61.0152 11.588C60.7538 10.9813 60.6232 10.3187 60.6232 9.6C60.6232 8.88133 60.7538 8.21867 61.0152 7.612C61.2765 7.00533 61.6405 6.478 62.1072 6.03C62.5738 5.57267 63.1245 5.218 63.7592 4.966C64.3938 4.714 65.0892 4.588 65.8452 4.588C66.5918 4.588 67.2778 4.714 67.9032 4.966C68.5378 5.20867 69.0885 5.55867 69.5552 6.016C70.0312 6.464 70.3952 6.99133 70.6472 7.598C70.9085 8.20467 71.0392 8.872 71.0392 9.6C71.0392 10.328 70.9085 10.9953 70.6472 11.602C70.3952 12.2087 70.0312 12.7407 69.5552 13.198C69.0885 13.646 68.5378 13.996 67.9032 14.248C67.2778 14.4907 66.5918 14.612 65.8452 14.612ZM65.8452 13.366C66.3865 13.366 66.8858 13.2727 67.3432 13.086C67.8098 12.8993 68.2112 12.638 68.5472 12.302C68.8925 11.9567 69.1585 11.5553 69.3452 11.098C69.5412 10.6407 69.6392 10.1413 69.6392 9.6C69.6392 9.05867 69.5412 8.55933 69.3452 8.102C69.1585 7.64467 68.8925 7.248 68.5472 6.912C68.2112 6.56667 67.8098 6.30067 67.3432 6.114C66.8858 5.92733 66.3865 5.834 65.8452 5.834C65.2945 5.834 64.7858 5.92733 64.3192 6.114C63.8618 6.30067 63.4605 6.56667 63.1152 6.912C62.7698 7.248 62.4992 7.64467 62.3032 8.102C62.1165 8.55933 62.0232 9.05867 62.0232 9.6C62.0232 10.1413 62.1165 10.6407 62.3032 11.098C62.4992 11.5553 62.7698 11.9567 63.1152 12.302C63.4605 12.638 63.8618 12.8993 64.3192 13.086C64.7858 13.2727 65.2945 13.366 65.8452 13.366ZM73.179 14.5V4.7H74.327L80.809 12.75H80.207V4.7H81.607V14.5H80.459L73.977 6.45H74.579V14.5H73.179ZM85.8143 8.928H90.8543V10.118H85.8143V8.928ZM85.9403 13.282H91.6523V14.5H84.5403V4.7H91.4563V5.918H85.9403V13.282Z",
    fill: "#1E1E1E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2215_20176",
    x1: 93.805,
    y1: 3.90039,
    x2: 157.145,
    y2: 15.6168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51087E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674211,
    stopColor: "#A14653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB8B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2215_20176",
    x1: 93.805,
    y1: 3.90039,
    x2: 157.145,
    y2: 15.6168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51087E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674211,
    stopColor: "#A14653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB8B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2215_20176",
    x1: 93.805,
    y1: 3.90039,
    x2: 157.145,
    y2: 15.6168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51087E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674211,
    stopColor: "#A14653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB8B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2215_20176",
    x1: 93.805,
    y1: 3.90039,
    x2: 157.145,
    y2: 15.6168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51087E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674211,
    stopColor: "#A14653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB8B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2215_20176",
    x1: 93.805,
    y1: 3.90039,
    x2: 157.145,
    y2: 15.6168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51087E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674211,
    stopColor: "#A14653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB8B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2215_20176",
    x1: 93.805,
    y1: 3.90039,
    x2: 157.145,
    y2: 15.6168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51087E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674211,
    stopColor: "#A14653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB8B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2215_20176",
    x1: 93.805,
    y1: 3.90039,
    x2: 157.145,
    y2: 15.6168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51087E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674211,
    stopColor: "#A14653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB8B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2215_20176",
    x1: 93.805,
    y1: 3.90039,
    x2: 157.145,
    y2: 15.6168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51087E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674211,
    stopColor: "#A14653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB8B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2215_20176",
    x1: 93.805,
    y1: 3.90039,
    x2: 157.145,
    y2: 15.6168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51087E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674211,
    stopColor: "#A14653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB8B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2215_20176",
    x1: 93.805,
    y1: 3.90039,
    x2: 157.145,
    y2: 15.6168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51087E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674211,
    stopColor: "#A14653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB8B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2215_20176",
    x1: 93.805,
    y1: 3.90039,
    x2: 157.145,
    y2: 15.6168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51087E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674211,
    stopColor: "#A14653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB8B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2215_20176",
    x1: 93.805,
    y1: 3.90039,
    x2: 157.145,
    y2: 15.6168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51087E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674211,
    stopColor: "#A14653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB8B23"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewgenOneMarvin);
export default __webpack_public_path__ + "static/media/NewgenOneMarvin.fe4b88b825af72d90e28badfdaec85e5.svg";
export { ForwardRef as ReactComponent };